<template>
    <div :class="[
        'relative',
        spacingClass,
        classes
    ]">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-gray-200"></div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    classes: {
        type: String,
        default: "",
    },
    spacing: {
        type: String,
        default: 'normal'
    }
  },
  computed: {
    spacingClass() {
        switch(this.spacing) {
            case 'normal': return 'py-10';
            case 'tight': return 'py-2';
            default: return 'py-10';
        }
    }
  }
};
</script>
